import { ITheme } from "../types";
import { lightThemeColors } from "./lightThemeColors";
import { shadows } from "./shadows";
import { spacing } from "./spacing";
import { borderRadius, borderWidth } from "./border";
import { darkThemeColors } from "./darkThemeColors";
import { typography } from "./typography";

const theme: ITheme = {
    light: {
        name: "Light",
        colors: lightThemeColors,
        typography,
        shadows,
        spacing,
        borderRadius,
        borderWidth
    },
    dark: {
        name: "Dark",
        colors: darkThemeColors,
        typography,
        shadows,
        spacing,
        borderRadius,
        borderWidth
    }
};

export default theme;
